import { render, staticRenderFns } from "./loker.vue?vue&type=template&id=52c7781c&"
import script from "./loker.vue?vue&type=script&lang=js&"
export * from "./loker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports